import React from 'react';
import './info.css'; // Fichier CSS renommé pour correspondre

const Info = () => {
  return (
    <div className="info-container">
      <div className="info-content">
      <h3>Qui cupiditate atque sit impedit molestiae.</h3>

        <p>Id temporibus cumque aut excepturi minus non fuga eveniet.</p>
        
        <p>Lorem ipsum dolor sit amet. Non ipsa dicta id libero quaerat ea porro molitita. Est quia voluptate qui earum vero ut voluptatum labore et impedit ipsam. Non deleniti quod non aspernatur tempora non distinctio fuga qui nihil ipsa ut dolor nostrum!</p>
        
        <p>Et consectetur alias quo cumque velit qui voluptatum erim.</p>
        
        <p>Non quasi consequuntur ut debilis suscipit et quia nisi ut molestias laboriosam sed autem explicabo qui quasi assumenda et aperiam deserunt. Et rerum explicabo est cumque officia in perspectius reclendis in odit Quis. Nam alias dolor ut sapiente alias ut omnis blanditis est autem dolores et pariatur temporibus cum quos exercitationem qui eligendi sint. Qui molitita distinctio qui iure tenetur aut assumenda autem est quas ipsa ut totam similique et dolorenque consequatur At molestiae aliquid.</p>
                
        <p>Eos sequi atque est restentile explicabo At officia dicta? Sed quaerat fugit qui quae facilis cum inventore quibendum ut posimus labore quo ductinus reprehenderit?</p>
        
        <h3>Qui aliquid iste ab vitae dolore.</h3>
        
        <p>Quo galisum quaerat qui veniam ducimus et nihil delectus aut quiaquam distinctio et voluptas consectetur non deleniti necidunt et expedita voluptas. Ut quam incidunt aut molestias provident aut magnam modi sed pertinendis nulla non sint voluptatum ut laborum esque est impedit omnis. Aut ttaque vitae ad quia undo et galisum vero?</p>
        
        <p>Non animi galisum et placeat eligendi. Et velit natus sit dignissimos sapiente qui officis labore et quis quos. Qui vitae eveniet in ipsa blanditis. Et galisum galisum et error impedit ut voluptas libero? Aut natus quis et omnis molitita. Et undo rerum et necessitatibus exercitationem. Non omnis sunt in facilis voluptas. Aut quia eveniet est assumenda quas.</p>
        
        <div className="about-info">
          <p>Joignez-nous par Whatsapp ou par appel direct</p>
          <p className="phone-number">(229) 01 41 37 37 41</p>
        </div>
      </div>
    </div>
  );
};

export default Info;